import type { PaletteMode } from '@mui/material';
import { createContext } from 'react';

export const ColorModeContext = createContext<{
  changeColorMode?: (mode: PaletteMode) => void;
}>({});
